import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { RootState } from "../store";
import { IUserLoginInfo, USER } from "../User/slice";
import {
  IDailyLog,
  IDailyReport,
  IMonthlyReport,
  IReportScore,
  loadDailyLog,
  loadDailyReport,
  loadMonthlyReport,
  loadMonthlyScore,
  MonthRequest,
  PeriodRequest,
  successLoadDailyLog,
  successLoadDailyReport,
  successLoadMonthlyReport,
  successLoadMonthlyScore,
} from "./slice";
import * as API from "../../apis";
import { RESULT_CODE } from "../../types";

function* handleLoadMonthlyReport({ payload }: PayloadAction<PeriodRequest>) {
  try {
    const email = yield select((state: RootState) => state[USER].email);
    const { user_token } = (yield select(
      (state: RootState) => state[USER].loginInfo
    )) as IUserLoginInfo;
    const resp = yield call(
      API.getMonthlyReport,
      email,
      user_token,
      payload.psn,
      payload.startTime,
      payload.endTime
    );

    const {
      resultcode,
      response: { result },
    } = resp.data as {
      resultcode: RESULT_CODE;
      response: { result: IMonthlyReport[] };
    };
    if (resultcode === "BC_ERR_OK") {
      yield put(successLoadMonthlyReport(result));
    }
  } catch (err) {
    console.error(err);
  }
}

function* handleLoadDailyReport({ payload }: PayloadAction<PeriodRequest>) {
  try {
    const email = yield select((state: RootState) => state[USER].email);
    const { user_token } = (yield select(
      (state: RootState) => state[USER].loginInfo
    )) as IUserLoginInfo;
    const resp = yield call(
      API.getDailyReport,
      email,
      user_token,
      payload.psn,
      payload.startTime,
      payload.endTime
    );

    const {
      resultcode,
      response: { result },
    } = resp.data as {
      resultcode: RESULT_CODE;
      response: { result: IDailyReport[] };
    };
    if (resultcode === "BC_ERR_OK") {
      yield put(successLoadDailyReport(result));
    }
  } catch (err) {
    console.error(err);
  }
}

function* handleLoadMonthlyScore({ payload }: PayloadAction<MonthRequest>) {
  try {
    const email = yield select((state: RootState) => state[USER].email);
    const { user_token } = (yield select(
      (state: RootState) => state[USER].loginInfo
    )) as IUserLoginInfo;
    const resp = yield call(
      API.getMonthlyScore,
      email,
      user_token,
      payload.psn,
      payload.month
    );

    const {
      resultcode,
      response: { result },
    } = resp.data as {
      resultcode: RESULT_CODE;
      response: { result: IReportScore[] };
    };
    if (resultcode === "BC_ERR_OK") {
      yield put(successLoadMonthlyScore(result));
    }
  } catch (err) {
    console.error(err);
  }
}

function* handleLoadDailyLog({ payload }: PayloadAction<PeriodRequest>) {
  try {
    const email = yield select((state: RootState) => state[USER].email);
    const { user_token } = (yield select(
      (state: RootState) => state[USER].loginInfo
    )) as IUserLoginInfo;
    const resp = yield call(
      API.getDailyLog,
      email,
      user_token,
      payload.psn,
      payload.startTime,
      payload.endTime
    );

    const { resultcode, response } = resp.data as {
      resultcode: RESULT_CODE;
      response: IDailyLog[];
    };
    if (resultcode === "BC_ERR_OK") {
      yield put(successLoadDailyLog(response));
    }
  } catch (err) {
    console.error(err);
  }
}

export function* watchReport() {
  yield takeLatest(loadDailyReport, handleLoadDailyReport);
  yield takeLatest(loadMonthlyReport, handleLoadMonthlyReport);
  yield takeLatest(loadMonthlyScore, handleLoadMonthlyScore);
  yield takeLatest(loadDailyLog, handleLoadDailyLog);
}
